<div class="flex items-center gap-3">
  <input type="date" [(ngModel)]="startDate" (change)="emitRange()" class="input input-bordered w-full max-w-xs" placeholder="Fecha inicial" />
  <span class="material-symbols-outlined text-gray-500">arrow_right_alt</span>
  <input type="date" [(ngModel)]="endDate" (change)="emitRange()" class="input input-bordered w-full max-w-xs" placeholder="Fecha final" />
</div>


